module.exports = __webpack_public_path__ + "media/images/logo-2-07b2b4fd226667cb44cb21d41b2cb910.png";